module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "article-container"
    }
  }, [_c('section', {
    staticClass: "movie"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("豆瓣电影Top 250")]), _vm._v(" "), _c('div', {
    staticClass: "sider-bar"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.nextPage(0)
      }
    }
  }, [_vm._v("Top 10")]), _vm._v(" "), _c('button', {
    attrs: {
      "herf": "javascript:",
      "disabled": _vm.disable
    },
    on: {
      "click": function($event) {
        _vm.nextPage(-1)
      }
    }
  }, [_vm._v("Prev")]), _vm._v(" "), _c('button', {
    attrs: {
      "herf": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.nextPage(1)
      }
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "dot1"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot2"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "articel-list"
  }, [_c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "aList"
  }, _vm._l((_vm.articles), function(article) {
    return _c('li', [_c('a', {
      attrs: {
        "href": article.alt
      },
      domProps: {
        "textContent": _vm._s(article.title)
      }
    })])
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a878bc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/doubanTop250.vue
// module id = 22
// module chunks = 0